import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(VDialog,{attrs:{"max-width":"400"},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}},[_c(VCard,[_c(VCardTitle,[_vm._v("Playing")]),_c('video',{attrs:{"src":_vm.videoSrc,"controls":"controls","height":"300","width":"400","controlslist":"nodownload"}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }